import style from "./ButtonB.module.css";

const ButtonB = ({ text, link }) => {
  return (
    <div className={style.divBtn}>
      <a href={link}>
        <button className={style.btn}> {text} </button>
      </a>
    </div>
  );
};

export default ButtonB;
